'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:inject:show');
}

var _invoke = require('../invoke');

/**
 * 将隐藏 webview 放到前台
 *
 * TODO: 验证下返回值
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof inject
 * @static
 * @name show
 * @param {String} name 隐藏 webview 名
 * @return {Promise}
 * @example
 *  hbnb.inject.show('name');
 */
module.exports = function(name) {
    if (process.env.NODE_ENV !== 'production') {
        debug('name is %s', name);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('inject', 'show', {
            name: name
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/inject/show.js
// module id = 594
// module chunks = 0